import "@inter-ikea-kompis/component-summary-page/lib/components/summary-page/SummaryPage.js";
import WrappedComponent from "@inter-ikea-kompis/component-summary-page/lib/components/summary-page/SummaryPage.js";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import KompisElementRegistry from '@inter-ikea-kompis/web-component/lib/registry/KompisElementRegistry.js';
class KompisSummaryPage extends React.Component {
    constructor() {
        super(...arguments);
        this.customElements = new KompisElementRegistry();
        this.listeners = {};
        this.ref = {
            current: null
        };
    }
    render() {
        return React.createElement(this.customElements.getInternalName("kompis-summary-page"), this.getForwardedProps(), this.props.children);
    }
    componentWillUnmount() {
        this.setState({
            element: null
        });
        this.removeAllListeners(this.ref.current);
        this.ref.current = null;
    }
    UNSAFE_componentWillMount() {
        this.customElements.define("kompis-summary-page", WrappedComponent);
    }
    focus() {
        this.ref.current.focus();
    }
    removeAllListeners(element) {
        for (const eventType in this.listeners) {
            const callback = this.listeners[eventType];
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, callback);
            }
            delete this.listeners[eventType];
        }
    }
    updateEventListener(element, callback, eventType) {
        if (callback !== this.listeners[eventType]) {
            if (typeof callback === 'function') {
                element.removeEventListener(eventType, this.listeners[eventType]);
            }
            this.listeners[eventType] = callback;
            if (typeof callback === 'function') {
                element.addEventListener(eventType, this.listeners[eventType]);
            }
        }
    }
    getForwardedProps() {
        const forwardedProps = {
            ref: this.onRef.bind(this),
            class: this.props.className,
            'data-element-name': "kompis-summary-page"
        };
        for (const key in this.props) {
            if (!(key in this['constructor']['propTypes'])) {
                forwardedProps[key] = this.props[key];
            }
        }
        return forwardedProps;
    }
    onRef(element) {
        if (element === null) {
            return;
        }
        if (element !== this.ref.current && this.ref.current !== null) {
            this.removeAllListeners(this.ref.current);
        }
        this.updateAllEventListeners(element, this.props);
        this.updateAllPropValues(element, this.props);
        this.ref.current = element;
    }
    updateAllPropValues(element, props) {
        element.addToCartState = props.addToCartState;
        element.addToListState = props.addToListState;
        element.addUnavailableProductsToList = props.addUnavailableProductsToList;
        element.analytics = props.analytics;
        element.assemblyServices = props.assemblyServices;
        element.assistanceCardApplicationName = props.assistanceCardApplicationName;
        element.buyInStore = props.buyInStore;
        element.collectableProducts = props.collectableProducts;
        element.collectedProducts = props.collectedProducts;
        element.configurationMeasures = props.configurationMeasures;
        element.confirmationCardState = props.confirmationCardState;
        element.confirmationCardType = props.confirmationCardType;
        element.contentToPrint = props.contentToPrint;
        element.customTabButtons = props.customTabButtons;
        element.defaultSortBy = props.defaultSortBy;
        element.designLink = props.designLink;
        element.disableLinks = props.disableLinks;
        element.enableMainMargins = props.enableMainMargins;
        element.enableMargins = props.enableMargins;
        element.failedShoppingItems = props.failedShoppingItems;
        element.financingOption = props.financingOption;
        element.homeDelivery = props.homeDelivery;
        element.images = props.images;
        element.includedProducts = props.includedProducts;
        element.kioskMainCTAButtonState = props.kioskMainCTAButtonState;
        element.linkCard = props.linkCard;
        element.locale = props.locale;
        element.localizedInformation = props.localizedInformation;
        element.logInAndSaveState = props.logInAndSaveState;
        element.measurementSystem = props.measurementSystem;
        element.measurements = props.measurements;
        element.messageSection = props.messageSection;
        element.pickingListPrintLayout = props.pickingListPrintLayout;
        element.printHoistTarget = props.printHoistTarget;
        element.productDescription = props.productDescription;
        element.productListAddable = props.productListAddable;
        element.productListLink = props.productListLink;
        element.productListRemovable = props.productListRemovable;
        element.productListSections = props.productListSections;
        element.productMeasures = props.productMeasures;
        element.productName = props.productName;
        element.saveDesignToProfile = props.saveDesignToProfile;
        element.screenshotAlt = props.screenshotAlt;
        element.screenshotUrl = props.screenshotUrl;
        element.securityInformation = props.securityInformation;
        element.settings = props.settings;
        element.shareDesignCard = props.shareDesignCard;
        element.shareDesignState = props.shareDesignState;
        element.shoppingProducts = props.shoppingProducts;
        element.showAddToBag = props.showAddToBag;
        element.showAssemblyServices = props.showAssemblyServices;
        element.showAssistanceCard = props.showAssistanceCard;
        element.showDesignText = props.showDesignText;
        element.showEditDesignButton = props.showEditDesignButton;
        element.showKioskMainCTAButton = props.showKioskMainCTAButton;
        element.showPrintButton = props.showPrintButton;
        element.showSaveDesign = props.showSaveDesign;
        element.showShareDesign = props.showShareDesign;
        element.showTotalPackageWeight = props.showTotalPackageWeight;
        element.startHeadingsAtH2 = props.startHeadingsAtH2;
        element.storeAvailabilities = props.storeAvailabilities;
        element.storeId = props.storeId;
        element.stores = props.stores;
        element.theme = props.theme;
        element.translations = props.translations;
        element.visibleModal = props.visibleModal;
        element.vpcCode = props.vpcCode;
        element.zipCode = props.zipCode;
        element.zipInCardState = props.zipInCardState;
    }
    updateAllEventListeners(element, props) {
        this.updateEventListener(element, props.onAddToCart, "addToCart");
        this.updateEventListener(element, props.onAddToCartClick, "addToCartClick");
        this.updateEventListener(element, props.onAddToList, "addToList");
        this.updateEventListener(element, props.onAddUnavailableProductsToListChange, "addUnavailableProductsToListChange");
        this.updateEventListener(element, props.onAddUnavailableToCartAndList, "addUnavailableToCartAndList");
        this.updateEventListener(element, props.onCollectProduct, "collectProduct");
        this.updateEventListener(element, props.onConfirmationCardStateChange, "confirmationCardStateChange");
        this.updateEventListener(element, props.onCopyDesign, "copyDesign");
        this.updateEventListener(element, props.onCopyDesignCodeClick, "copyDesignCodeClick");
        this.updateEventListener(element, props.onCopyDesignCodeReset, "copyDesignCodeReset");
        this.updateEventListener(element, props.onCopyDesignLinkClick, "copyDesignLinkClick");
        this.updateEventListener(element, props.onCopyDesignLinkReset, "copyDesignLinkReset");
        this.updateEventListener(element, props.onEditDesignButtonClick, "editDesignButtonClick");
        this.updateEventListener(element, props.onFinancialServicesContinueButtonClick, "financialServicesContinueButtonClick");
        this.updateEventListener(element, props.onFinancialServicesMoreInfoClick, "financialServicesMoreInfoClick");
        this.updateEventListener(element, props.onForgetZipCode, "forgetZipCode");
        this.updateEventListener(element, props.onKioskMainCtaButtonClick, "kioskMainCtaButtonClick");
        this.updateEventListener(element, props.onLinkCardClick, "linkCardClick");
        this.updateEventListener(element, props.onLogInAndSaveDesign, "logInAndSaveDesign");
        this.updateEventListener(element, props.onModalClose, "modalClose");
        this.updateEventListener(element, props.onModalOpen, "modalOpen");
        this.updateEventListener(element, props.onOpenZipIn, "openZipIn");
        this.updateEventListener(element, props.onPrintButtonClick, "printButtonClick");
        this.updateEventListener(element, props.onPrintQrCodeRendered, "printQrCodeRendered");
        this.updateEventListener(element, props.onProductListAdd, "productListAdd");
        this.updateEventListener(element, props.onProductListExpand, "productListExpand");
        this.updateEventListener(element, props.onProductListNameClick, "productListNameClick");
        this.updateEventListener(element, props.onProductListRemove, "productListRemove");
        this.updateEventListener(element, props.onResetAddToCartState, "resetAddToCartState");
        this.updateEventListener(element, props.onResetAddToListState, "resetAddToListState");
        this.updateEventListener(element, props.onSaveDesign, "saveDesign");
        this.updateEventListener(element, props.onSaveZipCode, "saveZipCode");
        this.updateEventListener(element, props.onSelectedImageIndexChange, "selectedImageIndexChange");
        this.updateEventListener(element, props.onSendByEmailInput, "sendByEmailInput");
        this.updateEventListener(element, props.onSendByEmailReset, "sendByEmailReset");
        this.updateEventListener(element, props.onSendByEmailSend, "sendByEmailSend");
        this.updateEventListener(element, props.onSendByEmailValidation, "sendByEmailValidation");
        this.updateEventListener(element, props.onShareDesign, "shareDesign");
        this.updateEventListener(element, props.onShareDesignCardStateChange, "shareDesignCardStateChange");
        this.updateEventListener(element, props.onSortListChange, "sortListChange");
        this.updateEventListener(element, props.onStoreSelectorChange, "storeSelectorChange");
        this.updateEventListener(element, props.onTabChange, "tabChange");
        this.updateEventListener(element, props.onUnavailableProductsModalContinue, "unavailableProductsModalContinue");
    }
}
KompisSummaryPage.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
    addToCartState: PropTypes.string,
    addToListState: PropTypes.string,
    addUnavailableProductsToList: PropTypes.bool,
    analytics: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    assemblyServices: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    assistanceCardApplicationName: PropTypes.string,
    buyInStore: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    collectableProducts: PropTypes.bool,
    collectedProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    configurationMeasures: PropTypes.string,
    confirmationCardState: PropTypes.string,
    confirmationCardType: PropTypes.string,
    contentToPrint: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    customTabButtons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    defaultSortBy: PropTypes.string,
    designLink: PropTypes.string,
    disableLinks: PropTypes.bool,
    enableMainMargins: PropTypes.bool,
    enableMargins: PropTypes.bool,
    failedShoppingItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    financingOption: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    homeDelivery: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    images: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    includedProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    kioskMainCTAButtonState: PropTypes.string,
    linkCard: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    locale: PropTypes.string.isRequired,
    localizedInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    logInAndSaveState: PropTypes.string,
    measurementSystem: PropTypes.string,
    measurements: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    messageSection: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    pickingListPrintLayout: PropTypes.string,
    printHoistTarget: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productDescription: PropTypes.string,
    productListAddable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productListLink: PropTypes.string,
    productListRemovable: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productListSections: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    productMeasures: PropTypes.string,
    productName: PropTypes.string,
    saveDesignToProfile: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    screenshotAlt: PropTypes.string,
    screenshotUrl: PropTypes.string,
    securityInformation: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    settings: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    shareDesignCard: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    shareDesignState: PropTypes.string,
    shoppingProducts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    showAddToBag: PropTypes.bool,
    showAssemblyServices: PropTypes.bool,
    showAssistanceCard: PropTypes.bool,
    showDesignText: PropTypes.bool,
    showEditDesignButton: PropTypes.bool,
    showKioskMainCTAButton: PropTypes.bool,
    showPrintButton: PropTypes.bool,
    showSaveDesign: PropTypes.bool,
    showShareDesign: PropTypes.bool,
    showTotalPackageWeight: PropTypes.bool,
    startHeadingsAtH2: PropTypes.bool,
    storeAvailabilities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    storeId: PropTypes.string,
    stores: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    theme: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    translations: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    visibleModal: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    vpcCode: PropTypes.string,
    zipCode: PropTypes.string,
    zipInCardState: PropTypes.string,
    onStoreSelectorChange: PropTypes.func,
    onSortListChange: PropTypes.func,
    onAddToCart: PropTypes.func,
    onAddToList: PropTypes.func,
    onAddToCartClick: PropTypes.func,
    onShareDesign: PropTypes.func,
    onSaveDesign: PropTypes.func,
    onLogInAndSaveDesign: PropTypes.func,
    onModalOpen: PropTypes.func,
    onModalClose: PropTypes.func,
    onTabChange: PropTypes.func,
    onSelectedImageIndexChange: PropTypes.func,
    onCopyDesign: PropTypes.func,
    onAddUnavailableProductsToListChange: PropTypes.func,
    onAddUnavailableToCartAndList: PropTypes.func,
    onUnavailableProductsModalContinue: PropTypes.func,
    onCollectProduct: PropTypes.func,
    onShareDesignCardStateChange: PropTypes.func,
    onSendByEmailInput: PropTypes.func,
    onSendByEmailValidation: PropTypes.func,
    onSendByEmailSend: PropTypes.func,
    onSendByEmailReset: PropTypes.func,
    onCopyDesignCodeClick: PropTypes.func,
    onCopyDesignCodeReset: PropTypes.func,
    onCopyDesignLinkClick: PropTypes.func,
    onCopyDesignLinkReset: PropTypes.func,
    onForgetZipCode: PropTypes.func,
    onSaveZipCode: PropTypes.func,
    onOpenZipIn: PropTypes.func,
    onConfirmationCardStateChange: PropTypes.func,
    onFinancialServicesContinueButtonClick: PropTypes.func,
    onFinancialServicesMoreInfoClick: PropTypes.func,
    onResetAddToCartState: PropTypes.func,
    onResetAddToListState: PropTypes.func,
    onProductListAdd: PropTypes.func,
    onProductListRemove: PropTypes.func,
    onKioskMainCtaButtonClick: PropTypes.func,
    onProductListExpand: PropTypes.func,
    onLinkCardClick: PropTypes.func,
    onPrintButtonClick: PropTypes.func,
    onEditDesignButtonClick: PropTypes.func,
    onPrintQrCodeRendered: PropTypes.func,
    onProductListNameClick: PropTypes.func
};
export default KompisSummaryPage;
